
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { DatatableService } from '../../../shared/services/datatable.service';
import { DatatableComponent, DataTablePagerComponent } from '@swimlane/ngx-datatable';
import { NotificationsService } from 'angular2-notifications';
import { HttpParams } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { SpringDatatablePagination } from '../../../shared/services/spring-integration/pagination/spring-datatable-pagination';
import { SpringDatatablePaginationService } from '../../../shared/services/spring-integration/pagination/spring-datatable-pagination.service';
import { DateUtilService } from '../../../shared/services/date-util.service';
import { EncriptyUtilService } from '../../../shared/services/encripty-util.service';
import { AgendaFinanceiraService } from './agenda-financeira.service';
import { IMyDpOptions } from 'mydatepicker';
import { ExportCsvService } from '../../../shared/services/export-csv.service';
import { DocumentoHelper } from '../../../shared/utils/documento.helper';

@Component({
  selector: 'ngx-agenda-financeira',
  templateUrl: './agenda-financeira.component.html',
  styleUrls: ['./agenda-financeira.component.scss']
})
export class AgendaFinanceiraComponent implements OnInit {

  @ViewChild('myTable', null)
  public myTable: DatatableComponent;
  @ViewChild('tablePager', null)
  public tablePager: DataTablePagerComponent;
  public datatablePagination: SpringDatatablePagination = new SpringDatatablePagination()

  public formAgendaFinanceiro = null;
  public rowData: any;
  public tableLimit = 12;
  public tipoStatus = null;
  public tipoEntidade = null;
  public tipoOperacao = null;
  public cnpjCpf = null;
  public exportar = null;
  public columnsTabe = null;
  public customLogin = null;

  activatedRoute: ActivatedRoute;

  myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'dd/mm/yyyy',
    showClearDateBtn: false,
    openSelectorOnInputClick: true,
    showTodayBtn: false,
    allowSelectionOnlyInCurrentMonth: false,
    dayLabels: { su: "Dom", mo: "Seg", tu: "Ter", we: "Qua", th: "Qui", fr: "Sex", sa: "Sab" },
    monthLabels: { 1: "Jan", 2: "Fev", 3: "Mar", 4: "Abr", 5: "Mai", 6: "Jun", 7: "Jul", 8: "Ago", 9: "Set", 10: "Out", 11: "Nov", 12: "Dez" },
    firstDayOfWeek: "su",
  };

  constructor(
    private formBuilder: FormBuilder,
    private service: AgendaFinanceiraService,
    private datatableService: DatatableService,
    private router: Router,
    private route: ActivatedRoute,
    private notifications: NotificationsService,
    private spinnerService: NgxSpinnerService,
    private paginationService: SpringDatatablePaginationService,
    private dateUtilService: DateUtilService,
    private encriptyService: EncriptyUtilService,
    private exportCsvService: ExportCsvService,

  ) {

    this.paginationService.setDatatablePagination(this.datatablePagination);

    this.tipoStatus = [
      {
        status: 'AGUARDANDO_NOTIFICACAO',
        descricao: 'AGUARDANDO NOTIFICAÇÃO'
      },
      {
        status: 'DUPLICADA',
        descricao: 'DUPLICADA'
      },
      {
        status: 'ERRO',
        descricao: 'ERRO'
      },
      {
        status: 'FINALIZADO',
        descricao: 'FINALIZADO'
      },
      {
        status: 'NEGADA',
        descricao: 'NEGADA'
      },
      {
        status: 'SALDO_DIVERGENTE',
        descricao: 'SALDO DIVERGENTE'
      },
      {
        status: 'SALDO_INDISPONIVEL',
        descricao: 'SALDO INDISPONÍVEL'
      },
    ];

    this.tipoOperacao = [
      {
        status: 'BOLETO',
        descricao: 'BOLETO'
      },
      {
        status: 'RECARGA',
        descricao: 'RECARGA'
      },
      {
        status: 'TRANSFERENCIA',
        descricao: 'TED'
      },
    ];

    this.tipoEntidade = [
      {
        status: 'TOP_EMPRESA',
        descricao: 'CLIENTE'
      },
      {
        status: 'TOP_PESSOA',
        descricao: 'USUÁRIO'
      },
    ];

    this.columnsTabe = [
      { columnName: "agencia", newColumnName: "Agencia" },
      { columnName: "bonus", newColumnName: "Bonus" },
      { columnName: "cartaoPrePagoId", newColumnName: "Cartao PrePago Id" },
      { columnName: "cartaoPrePagoIdValor", newColumnName: "Cartao PrePago Id Valor" },
      { columnName: "checksum", newColumnName: "Checksum" },
      { columnName: "codigoBanco", newColumnName: "Codigo Banco" },
      { columnName: "contaComDigito", newColumnName: "Conta" },
      { columnName: "cpfCnpj", newColumnName: "cpfCnpj" },
      { columnName: "dataCadastro", newColumnName: "Data Cadastro" },
      { columnName: "descricao", newColumnName: "Descricao" },
      { columnName: "descricaoOperadora", newColumnName: "Descricao Operadora" },
      { columnName: "entidade", newColumnName: "Entidade" },
      { columnName: "entidadeId", newColumnName: "Entidade Id" },
      { columnName: "id", newColumnName: "ID" },
      { columnName: "linhaDigitavel", newColumnName: "Linha Digitavel" },
      { columnName: "nome", newColumnName: "Nome" },
      { columnName: "nomeBanco", newColumnName: "Nome Banco" },
      { columnName: "numeroTelefone", newColumnName: "Numero Telefone" },
      { columnName: "razaoSocialNome", newColumnName: "Razao Social" },
      { columnName: "recebiveisMaiores30dias", newColumnName: "Recebiveis Maiores 30 dias" },
      { columnName: "recebiveisMenores30dias", newColumnName: "Recebiveis Menores 30 dias" },
      { columnName: "saldoContaPagamento", newColumnName: "Saldo Conta Pagamento" },
      { columnName: "status", newColumnName: "Status" },
      { columnName: "tipoContaBancaria", newColumnName: "Tipo Conta Bancaria" },
      { columnName: "tipoOperacao", newColumnName: "Tipo Operacao" },
      { columnName: "transactionId", newColumnName: "Transaction Id" },
      { columnName: "ultimaAtualizacao", newColumnName: "Ultima Atualizacao" },
      { columnName: "validade", newColumnName: "Validade" },
      { columnName: "valorBoleto", newColumnName: "Valor Boleto" },
      { columnName: "valorOperacao", newColumnName: "Valor Operacao" },
      { columnName: "valorRecarga", newColumnName: "Valor Recarga" },

    ]


  }

  ngOnInit() {

    let resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom);
    document.title = this.customLogin.title;
    this.datatableService.subscribeTable(this.myTable);

    this.formAgendaFinanceiro = this.formBuilder.group({

      status: [null],
      dataInicio: [null],
      dataFim: [null],
      cnpjCpf: [null],
      tipoEntidade: [null],
      tipoOperacao: [null],

    });

  }

  buscarMonitoramento(data: any, page?: any) {

    let params = new HttpParams();

    params = params.append('size', String(this.tableLimit))

    if (page && page != null) {
      params = params.append('page', String(page));
    }

    if (data.dataInicio != null) {
      let dataInicio: any = this.dateUtilService.datepickerTransformDate(data.dataInicio, 'YYYY-MM-DD');
      params = params.append('dataInicio', dataInicio)
    }
    if (data.dataFim != null) {
      let dataFim: any = this.dateUtilService.datepickerTransformDate(data.dataFim, 'YYYY-MM-DD');
      params = params.append('dataFim', dataFim)
    }
    if (data.status != null) {
      params = params.append('status', data.status)
    }
    if (data.cnpjCpf != null && data.cnpjCpf !== '') {
      params = params.append('cpfCnpj', this.normalizarCnpjCpfParaBackend(data.cnpjCpf))
    }
    if (data.tipoEntidade != null) {
      params = params.append('entidade', data.tipoEntidade)
    }
    if (data.tipoOperacao != null) {
      params = params.append('tipoOperacao', data.tipoOperacao)
    }

    this.spinnerService.show();

    this.service.logMonitoramento(params, (response => {

      this.rowData = response.content
      this.spinnerService.hide();
      this.rowData = this.rowData.map(data => {

        return {

          razaoSocialNome: data.razaoSocialNome,
          cpfCnpj: data.cpfCnpj,
          tipoOperacao: data.tipoOperacao,
          valorOperacao: data.valorOperacao,
          status: data.status,
          dataCadastro: moment(data.dataCadastro).format('DD/MM/YYYY'),

        }

      })

      this.paginationService.setInfo(response);
    }), (error) => this.spinnerService.hide());

  }

  exportarMonitoramento(data: any, page?: any) {

    let params = new HttpParams();

    params = params.append('size', String('999999999'))

    if (page && page != null) {
      params = params.append('page', String(page));
    }

    if (data.dataInicio != null) {
      let dataInicio: any = this.dateUtilService.datepickerTransformDate(data.dataInicio, 'YYYY-MM-DD');
      params = params.append('dataInicio', dataInicio)
    }
    if (data.dataFim != null) {
      let dataFim: any = this.dateUtilService.datepickerTransformDate(data.dataFim, 'YYYY-MM-DD');
      params = params.append('dataFim', dataFim)
    }
    if (data.status != null) {
      params = params.append('status', data.status)
    }
    if (data.cnpjCpf != null && data.cnpjCpf !== '') {
      params = params.append('cpfCnpj', this.normalizarCnpjCpfParaBackend(data.cnpjCpf))
    }
    if (data.tipoEntidade != null) {
      params = params.append('entidade', data.tipoEntidade)
    }
    if (data.tipoOperacao != null) {
      params = params.append('tipoOperacao', data.tipoOperacao)
    }

    this.spinnerService.show();

    this.service.logMonitoramento(params, (response => {

      this.rowData = response.content
      this.exportar = response.content.length;

      this.rowData = this.rowData.map(data => {

        return {

          agencia: data.agencia,
          bonus: data.bonus,
          cartaoPrePagoId: data.cartaoPrePagoId,
          cartaoPrePagoIdValor: data.cartaoPrePagoIdValor,
          checksum: data.checksum,
          codigoBanco: data.codigoBanco,
          contaComDigito: data.contaComDigito,
          cpfCnpj: data.cpfCnpj,
          dataCadastro: moment(data.dataCadastro).format('DD/MM/YYYY'),
          descricao: data.descricao,
          descricaoOperadora: data.descricaoOperadora,
          entidade: data.entidade,
          entidadeId: data.entidadeId,
          id: data.id,
          linhaDigitavel: data.linhaDigitavel,
          nome: data.nome,
          nomeBanco: data.nomeBanco,
          numeroTelefone: data.numeroTelefone,
          razaoSocialNome: data.razaoSocialNome,
          recebiveisMaiores30dias: data.recebiveisMaiores30dias,
          recebiveisMenores30dias: data.recebiveisMenores30dias,
          saldoContaPagamento: data.saldoContaPagamento,
          status: data.status,
          tipoContaBancaria: data.tipoContaBancaria,
          tipoOperacao: data.tipoOperacao,
          transactionId: data.transactionId,
          ultimaAtualizacao: data.ultimaAtualizacao,
          validade: data.validade,
          valorBoleto: data.valorBoleto,
          valorOperacao: data.valorOperacao,
          valorRecarga: data.valorRecarga,

        }

      })

      if (this.exportar == 0) {
        this.notifications.warn('Não há dados para exportar!');
      } else {
        this.exportCsvService.exportCsv(this.rowData, this.columnsTabe, ',', 'agendaFinanceira');
      }
      this.spinnerService.hide()

    }), (error) => this.spinnerService.hide());


  }

  gotoEdit(data) {

    let id = this.encriptyService.encriptyBySecretKey('' + data.id)

    let params = {

      'id': id,

    }

    this.router.navigate(['/pages/monitoramento/log-agenda-financeira'], { relativeTo: this.activatedRoute, queryParams: params });

  }

  gotoLimpar() {

    this.formAgendaFinanceiro = this.formBuilder.group({
      nome: [null],
      login: [null],
      status: [null],

    });

    this.datatablePagination.rowData = [null];
    this.datatablePagination.totalElements = 0;

  }

  getCpfCnpjMask(): string {
    return DocumentoHelper.getMascaraCpfCnpj(this.cnpjCpf);
  }

  formatarDocumento(valor: string | null | undefined): string {
    return DocumentoHelper.formatarDocumento(valor);
  }

  private normalizarCnpjCpfParaBackend(value: any): string {
    if (value == null) return '';
    const str = String(value);
    if (str === '') return '';
    const tipo = DocumentoHelper.detectarTipoDocumento(str);
    return DocumentoHelper.normalizarParaEnvio(str, tipo);
  }

  previousPage() {
    this.router.navigate(['/iot-dashboard']);
  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }

  getButtonTerciario() {
    if (this.customLogin != null) {
      return this.customLogin.terciario;
    }
  }


}
